// extracted by mini-css-extract-plugin
export default {"borderRadius":"borderRadius__1kgIF","primary":"primary__RvvZO","tile":"tile__O6GQC"};